import script from "./PasswordResetEmailNotice.vue?vue&type=script&setup=true&lang=js"
export * from "./PasswordResetEmailNotice.vue?vue&type=script&setup=true&lang=js"

import "./PasswordResetEmailNotice.vue?vue&type=style&index=0&id=27760d4f&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-27760d4f"]])

export default __exports__